const cloudinaryOptimizations =
  "q_auto:eco,f_auto,c_scale,dpr_auto,w_400,h_400";
const imageSrcRoot = `https://images.sonder.com/image/upload/${cloudinaryOptimizations}`;

export const leisureStandards = {
  checkIn: {
    imageUrl: `${imageSrcRoot}/v1566420631/catalina/standards/check-in.jpg`,
    altKey: "Photo representing self check-in",
    active: true,
    translateKey: "components.sonderStandards.checkIn",
  },
  cleaning: {
    imageUrl: `${imageSrcRoot}/v1585694497/catalina/standards/cleaning-2.jpg`,
    altKey: "Photo representing cleaning",
    active: true,
    translateKey: "components.sonderStandards.cleaning",
  },
  wifi: {
    imageUrl: `${imageSrcRoot}/v1578523565/catalina/standards/wifi-business.jpg`,
    altKey: "Photo representing fast wifi",
    active: true,
    translateKey: "components.sonderStandards.wifi",
  },
  bath: {
    imageUrl: `${imageSrcRoot}/v1566420631/catalina/standards/soaps.jpg`,
    altKey: "Photo representing bath essentials",
    active: true,
    translateKey: "components.sonderStandards.bath",
  },
  mattress: {
    imageUrl: `${imageSrcRoot}/v1566420632/catalina/standards/mattress.jpg`,
    altKey: "Photo representing a mattress",
    active: true,
    translateKey: "components.sonderStandards.mattress",
  },
  kitchen: {
    imageUrl: `${imageSrcRoot}/v1578523564/catalina/standards/kitchen-business.jpg`,
    altKey: "Photo representing a kitchen",
    active: true,
    translateKey: "components.sonderStandards.kitchen",
  },
  towels: {
    imageUrl: `${imageSrcRoot}/v1566420631/catalina/standards/towels.jpg`,
    altKey: "Photo representing towels",
    active: true,
    translateKey: "components.sonderStandards.towels",
  },
  laundry: {
    imageUrl: `${imageSrcRoot}/v1566605209/catalina/standards/laundry.jpg`,
    altKey: "Photo representing in-unit laundry",
    active: true,
    translateKey: "components.sonderStandards.laundry",
  },
  coffee: {
    imageUrl: `${imageSrcRoot}/v1566420631/catalina/standards/coffee.jpg`,
    altKey: "Photo representing coffee",
    active: true,
    translateKey: "components.sonderStandards.coffee",
  },
  support: {
    imageUrl: `${imageSrcRoot}/v1566623575/catalina/standards/support.jpg`,
    altKey: "Photo representing customer support",
    active: true,
    translateKey: "components.sonderStandards.support",
  },
};

export const extendedStayStandards = {
  checkIn: {
    imageUrl: `${imageSrcRoot}/v1578523564/catalina/standards/check-in-business.jpg`,
    altKey: "Photo representing self check-in",
    active: true,
    translateKey: "components.extendedStay.sonderStandards.checkIn",
  },
  cleaning: {
    imageUrl: `${imageSrcRoot}/v1585694497/catalina/standards/cleaning-2.jpg`,
    altKey: "Photo representing cleaning",
    active: true,
    translateKey: "components.extendedStay.sonderStandards.cleaning",
  },
  wifi: {
    imageUrl: `${imageSrcRoot}/v1578523565/catalina/standards/wifi-business.jpg`,
    altKey: "Photo representing fast wifi",
    active: true,
    translateKey: "components.extendedStay.sonderStandards.wifi",
  },
  bath: {
    imageUrl: `${imageSrcRoot}/v1578523564/catalina/standards/bath-business.jpg`,
    altKey: "Photo representing bath essentials",
    active: true,
    translateKey: "components.extendedStay.sonderStandards.bath",
  },
  mattress: {
    imageUrl: `${imageSrcRoot}/v1578523564/catalina/standards/matress-business.jpg`,
    altKey: "Photo representing a comfortable bed",
    active: true,
    translateKey: "components.extendedStay.sonderStandards.mattress",
  },
  kitchen: {
    imageUrl: `${imageSrcRoot}/v1578523564/catalina/standards/kitchen-business.jpg`,
    altKey: "Photo representing a kitchen",
    active: true,
    translateKey: "components.extendedStay.sonderStandards.kitchen",
  },
  towels: {
    imageUrl: `${imageSrcRoot}/v1578523565/catalina/standards/towels-business.jpg`,
    altKey: "Photo representing towels",
    active: true,
    translateKey: "components.extendedStay.sonderStandards.towels",
  },
  laundry: {
    imageUrl: `${imageSrcRoot}/v1566605209/catalina/standards/laundry.jpg`,
    altKey: "Photo representing in-unit laundry",
    active: true,
    translateKey: "components.extendedStay.sonderStandards.laundry",
  },
  coffee: {
    imageUrl: `${imageSrcRoot}/v1566420631/catalina/standards/coffee.jpg`,
    altKey: "Photo representing coffee",
    active: true,
    translateKey: "components.extendedStay.sonderStandards.coffee",
  },
  support: {
    imageUrl: `${imageSrcRoot}/v1566623575/catalina/standards/support.jpg`,
    altKey: "Photo representing customer support",
    active: true,
    translateKey: "components.extendedStay.sonderStandards.support",
  },
};

export const longTermLeaseStandards = {
  checkIn: {
    imageUrl: `${imageSrcRoot}/v1578523564/catalina/standards/check-in-business.jpg`,
    altKey: "Photo representing self check-in",
    active: true,
    translateKey: "components.longTermLease.sonderStandards.checkIn",
  },
  cleaning: {
    imageUrl: `${imageSrcRoot}/v1585694497/catalina/standards/cleaning-2.jpg`,
    altKey: "Photo representing cleaning",
    active: true,
    translateKey: "components.longTermLease.sonderStandards.cleaning",
  },
  wifi: {
    imageUrl: `${imageSrcRoot}/v1578523565/catalina/standards/wifi-business.jpg`,
    altKey: "Photo representing fast wifi",
    active: true,
    translateKey: "components.longTermLease.sonderStandards.wifi",
  },
  bath: {
    imageUrl: `${imageSrcRoot}/v1578523564/catalina/standards/bath-business.jpg`,
    altKey: "Photo representing bath essentials",
    active: true,
    translateKey: "components.longTermLease.sonderStandards.bath",
  },
  mattress: {
    imageUrl: `${imageSrcRoot}/v1578523564/catalina/standards/matress-business.jpg`,
    altKey: "Photo representing a comfortable bed",
    active: true,
    translateKey: "components.longTermLease.sonderStandards.mattress",
  },
  kitchen: {
    imageUrl: `${imageSrcRoot}/v1578523564/catalina/standards/kitchen-business.jpg`,
    altKey: "Photo representing a kitchen",
    active: true,
    translateKey: "components.longTermLease.sonderStandards.kitchen",
  },
  towels: {
    imageUrl: `${imageSrcRoot}/v1578523565/catalina/standards/towels-business.jpg`,
    altKey: "Photo representing towels",
    active: true,
    translateKey: "components.longTermLease.sonderStandards.towels",
  },
  laundry: {
    imageUrl: `${imageSrcRoot}/v1566605209/catalina/standards/laundry.jpg`,
    altKey: "Photo representing in-unit laundry",
    active: true,
    translateKey: "components.longTermLease.sonderStandards.laundry",
  },
  coffee: {
    imageUrl: `${imageSrcRoot}/v1566420631/catalina/standards/coffee.jpg`,
    altKey: "Photo representing coffee",
    active: true,
    translateKey: "components.longTermLease.sonderStandards.coffee",
  },
  support: {
    imageUrl: `${imageSrcRoot}/v1566623575/catalina/standards/kitchen.jpg`,
    altKey: "Photo representing cooking essentials",
    active: true,
    translateKey: "components.longTermLease.sonderStandards.cooking",
  },
};

import {
  IconApartment,
  IconKeypadHand,
  IconSpeechBubbles,
  IconWifi,
} from "icons";

export const propertyStandards = {
  designerSpaces: {
    Icon: IconApartment,
    translateKey: "components.sonderStandards.designerSpaces",
  },
  keylessEntry: {
    Icon: IconKeypadHand,
    translateKey: "components.sonderStandards.keylessEntry",
  },
  wifi: {
    Icon: IconWifi,
    translateKey: "components.sonderStandards.fastFreeWifi",
  },
  digitalConcierge: {
    Icon: IconSpeechBubbles,
    translateKey: "components.sonderStandards.digitalConcierge",
  },
};
